import React from 'react'

import Button from '@react/react-spectrum/Button'
import ModalTrigger from '@react/react-spectrum/ModalTrigger'
import { Table, THead, TBody, TH, TD, TR } from '@react/react-spectrum/Table'

import Delete from '@react/react-spectrum/Icon/Delete'
import Duplicate from '@react/react-spectrum/Icon/Duplicate'
import UsersShare from '@react/react-spectrum/Icon/UsersShare'

import { DuplicateProjectDialog } from 'components/DuplicateProject'
import { DeleteProjectDialog } from 'components/DeleteProject'
import { ShareProjectDialog } from 'components/ShareProject/ShareProject'
import ProjectTypeIcon from 'components/ProjectTypeIcon'

import { getConfig, deleteLaunchProperty, deleteDataStream } from 'services/project'
import { fromNow } from 'utils/datetime'

export default ({ projects, showOwner, projectClickHandler, projectDeleteHandler, projectDuplicateHandler }) => (
  <Table className='projectTable'>
    <THead>
      <TH>Thumbnail</TH>
      <TH>Type</TH>
      <TH>ID</TH>
      <TH>Name</TH>
      {showOwner && <TH>Owner</TH>}
      <TH>Updated</TH>
      <TH>Actions</TH>
    </THead>
    <TBody>
      {projects.map((project) => (
        <ProjectRow
          key={project?.meta?.id}
          propertyID={project?.integrations?.launch?.propertyID}
          project={project}
          onClick={projectClickHandler(project)}
          onDelete={projectDeleteHandler(project)}
          onDuplicate={projectDuplicateHandler(project)}
          showOwner={showOwner}
        />
      ))}
    </TBody>
  </Table>
)

export const ProjectRow = ({ project, showOwner, onClick, onDelete, propertyID, onDuplicate }) => {
  const canDelete = typeof onDelete === 'function'
  const config = getConfig(project.meta.type)

  const handleDeleteSubmit = async (deleteTags) => {
    if (canDelete) {
      onDelete(project?.meta?.id)
    }
    if (deleteTags && propertyID) {
      await deleteDataStream(project?.integrations?.launch?.id)
      deleteLaunchProperty(project?.integrations?.launch?.id)
    }
  }

  return (
    <TR onClick={onClick}>
      <TD className='projectTable__image'>
        <img src={project.meta.thumbnail} alt='project thubnail' />
      </TD>
      <TD className='projectTable__type'>
        <ProjectTypeIcon icon={project.meta.typeIcon} projectType={project.meta.type} />
      </TD>
      <TD className='projectTable__id'>
        <div>{project?.meta?.id}</div>
      </TD>
      <TD className='projectTable__title'>
        <div>{project.meta.title}</div>
      </TD>
      {showOwner && (
        <TD className='projectTable__owner'>
          <div>{project.owner}</div>
        </TD>
      )}
      <TD className='projectTable__updated'>
        <em>
          {fromNow(project.updatedAt)}
          <br /> by {project.updatedBy}
        </em>
      </TD>
      <TD className={'projectTable__actions' + (canDelete ? '' : ' projectTable__actions--short')}>
        <div>
          <ModalTrigger>
            <Button variant='tool' icon={<UsersShare />} onClick={(e) => e.stopPropagation()} aria-label='Share' />
            <ShareProjectDialog project={project} projectConfig={config} />
          </ModalTrigger>
          <ModalTrigger>
            <Button variant='tool' icon={<Duplicate />} onClick={(e) => e.stopPropagation()} aria-label='Duplicate' />
            <DuplicateProjectDialog
              projectId={project?.meta?.id}
              title={project.meta.title + ' Copy'}
              drNumber=''
              onSubmit={onDuplicate}
            />
          </ModalTrigger>
          {canDelete && (
            <ModalTrigger>
              <Button variant='tool' icon={<Delete />} onClick={(e) => e.stopPropagation()} aria-label='Delete' />
              <DeleteProjectDialog
                projectId={project?.meta?.id}
                title={project.meta.title + ' Copy'}
                drNumber=''
                onSubmit={handleDeleteSubmit}
                propertyID={propertyID}
              />
            </ModalTrigger>
          )}
        </div>
      </TD>
    </TR>
  )
}
